<template>
  <div class="question-alternatives">
    <QuestionAlternative
      v-for="(option, index) in options"
      :index="index"
      :key="option.id"
      :title="option.title"
      :selected="option.title == selected"
      @click="selected = option.title"
    />
  </div>
</template>

<script>
import QuestionAlternative from "./QuestionAlternative.vue";
export default {
  components: {
    QuestionAlternative
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      selected: this.value
    };
  },
  watch: {
    selected(v) {
      this.$emit("input", v);
    },
    value(v) {
      this.selected = v;
    }
  }
};
</script>
